import { useSelector } from 'react-redux';
import { ReduxState } from '../types';
import { UserRole, UserType } from '../constants/user_types';

const useIsClientOperator = (): boolean => {
  const currentUser = useSelector((state: ReduxState) => state.account.user);
  return (currentUser?.role === UserRole.OPERATOR)
    && (currentUser?.type === UserType.CLIENT
      || currentUser?.type === UserType.MULTI_ACCOUNT_CLIENT);
};

export default useIsClientOperator;
